import React from 'react';
import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import { useIntl } from 'react-intl';
import Box from 'ui/Box';
import { isNAMarket } from 'i18n/i18nUtils';
import styled from 'styled-components';
import media from 'ui/media';
import { isMobile } from 'utils/platform';

const Wrapper = styled(Box)`
  padding: ${({ theme }) => theme.space.s} 0;
  ${media.mobile`
  padding: 0.5rem 0.75rem 0.75rem 0.75rem;
`};
`;

const UnsafeFrameMessage = () => {
  const { formatMessage } = useIntl();
  return isNAMarket() ? null : (
    <Wrapper>
      <SkapaInlineMessage
        title={formatMessage({ id: 'storageone.unsafeFramesMessageTitle' })}
        body={formatMessage({ id: 'storageone.unsafeFramesMessageBody' })}
        variant={InlineMessageVariantEnum.INFORMATIVE}
        ssrIcon={InformationCircle}
        subtle={isMobile() ? true : false}
      />
    </Wrapper>
  );
};

export default UnsafeFrameMessage;
